import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const CompanySetting = lazy(() => import("@/pages/CompanySetting/CompanySetting"));

const CompanySettingRoute: RouteConfig = {
    path: "companysetting",
    element: <CompanySetting />,
    pageName: "Company Setting",
    sidebar: { show: true, icon: "" },
    permission: ["CompanySettingsEdit"],
}

export default CompanySettingRoute;